
<template>
	<vs-popup
		:active.sync="$props.popupActive"
		:title="'Notes SEO : ' + $props.prospect_url"
	>
		<div class="chart-container">
			<EChart :options="chartOptions" :key="chartDivKey" />
		</div>
	</vs-popup>
</template>
  
  <script>
import EChart from "../../../echarts/EChart.vue";

export default {
	name: "ProspectRadarChartPopup",
	components: {
		EChart,
	},
	props: {
		popupActive: {
			type: Boolean,
			required: true,
		},
		prospectId: {
			type: Number,
			required: true,
		},
		prospect_url: {
			type: String,
			required: true,
		},
		notes: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			chartDivKey: 0,
			chartOptions: {
				title: {
					text: "Apercu des données",
				},
				legend: {
					data: ["Analyse"],
				},
				radar: {
					// shape: 'circle',
					indicator: [],
					axisName: {
						color: "#fff",
						backgroundColor: "#666",
						borderRadius: 3,
						padding: [3, 5],
					},
				},
				series: [
					{
						name: "",
						type: "radar",
						areaStyle: {},
						data: [
							{
								value: [],
								name: "Analysis",
								label: {
									show: true,
									color: "black",
									formatter: function (params) {
										return params.value.toFixed(1);
									},
								},
							},
						],
					},
				],
			},
			// Radar
			radarData: {},
		};
	},
	created() {
		this.fetchRadarData();
	},
	methods: {
		async fetchRadarData() {
			await new Promise((resolve) => setTimeout(resolve, 1000));
			let dummyData = {
				Indexation: 5,
				Contenu: 7,
				Exploration: 8,
				Netlinking: 6,
			};
			const allNotes = this.notes;
			let keys = Object.keys(allNotes);
			let indicators = [];
			let values = [];
			// assigning indicator data
			for (let i = 0; i < keys.length; i++) {
				indicators.push({
					name: keys[i],
					max: 10,
				});
				values.push(allNotes[keys[i]]);
			}
			// DUMMY DATA
			let dummyKeys = Object.keys(dummyData);
			for (let j = 0; j < dummyKeys.length; j++) {
				indicators.push({
					name: dummyKeys[j],
					max: 10,
				});
				values.push(dummyData[dummyKeys[j]]);
			}

			this.chartOptions.radar.indicator = indicators;
			this.chartOptions.series[0].data[0].value = values;
			this.chartDivKey++;

			// fetch data from the server
		},
	},
};
</script>
  
  <style>
.chart-container {
	position: relative;
	height: 70vh;
	width: 70wh;
	overflow: hidden;
}
/* You can add some styles here if needed */
</style>
  